export const socialType = {
  GOOGLE: 'google',
  FACEBOOK: 'facebook',
};

export type SocialTypes = typeof socialType[keyof typeof socialType];
